import React from 'react';

interface SparklineProps {
  /** Bucket values, oldest first */
  values: { label: string; count: number }[];
  /** Light variant for the white ProfilePanel body; default is the dark modal */
  light?: boolean;
}

/** N-bucket mini bar chart. Top ~30% buckets get the stronger shade. */
const Sparkline: React.FC<SparklineProps> = ({ values, light }) => {
  const max = Math.max(...values.map((value) => value.count), 1);
  const hotThreshold = max * 0.7;
  const base = light ? 'bg-blue-200' : 'bg-blue-900';
  const hot = light ? 'bg-blue-500' : 'bg-blue-400';
  const empty = light ? 'bg-gray-200' : 'bg-gray-700';

  return (
    <div className="flex items-end gap-0.5 h-10">
      {values.map((value) => (
        <div
          key={value.label}
          className={`flex-1 rounded-t-sm ${value.count === 0 ? `${empty} h-0.5` : value.count >= hotThreshold ? hot : base}`}
          style={value.count > 0 ? { height: `${Math.max(8, (value.count / max) * 100)}%` } : undefined}
          title={`${value.label}: ${value.count}`}
        />
      ))}
    </div>
  );
};

export default Sparkline;
